/*
* Reserve study report - chart adjustment form
*/

import * as React from 'react';
import * as _ from 'lodash';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { Button, ButtonToolbar } from 'react-bootstrap';

export const PortalReserveStudyFormSection = ({ title, className = '', ...rest }) => {
    return (
        <div className={`reserve-study-form-section ${className}`}>
            <KendoWrappers.KendoFormSection title={title}>
                {rest.children}
            </KendoWrappers.KendoFormSection>
        </div>
    );
};

export const ChartFormRow = ({ children, ...rest }) => {
    return (
        <Row className="chart-form-row">
            <Col xs={12}>
                {children}
            </Col>
        </Row>
    );
};

export const defaultInputProps = {
    colLabelXs: 6,
    colInputXs: 6,
    colLabelLg: 5,
    colInputLg: 7,
    colLabelXl: 6,
    colInputXl: 6,
    rowClassName: 'no-gutter portal-chart-form-row',
};

export const PortalReserveStudyFormBeginningAssumptions = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    handleUpdateScenarioButton,
    handleCopyScenarioButton,
    handleOptimizeScenarioButton,
    handleEditOrderButton,
    numFormChanges,
    handleViewPdf,
    formData,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    const canUpdateScenario = (_.get(formData, 'scenarioCanUpdate', false)) ? true : false;
    const canCopyScenario = true;
    const disableButtons = (numFormChanges > 0) ? false : true;

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => {
            handleFormInputChange(n, v);
        },
    });

    const inputPropsPercentage = _.merge({}, defaultInputProps, {
        onChange: (n, v) => {
            const val = (v > 0) ? v / 100 : 0;
            handleFormInputChange(n, val);
        }
    });

    let copyScenarioButtonProps = {
        bsStyle: 'success',
        bsSize: 'sm',
        title: appText('save-as-new-scenario'),
    };

    let updateScenarioButtonProps = {
        bsStyle: 'success',
        bsSize: 'sm',
        title: appText('save-changes-to-scenario'),
    };

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        // className: 'inventory-detail-input-full-width',
        colLabelXs: 12,
        colInputXs: 12,
    });

    const buttonOptions = {
        bsSize: 'sm',
        disabled: (disableButtons) ? true : false,
    };

    // console.log(`PortalReserveStudyFormSection adjustments formdata canUpdateScenario ${canUpdateScenario}`, formData);

    return (
        <PortalReserveStudyFormSection title={appText('adjustments')} className="portal-report-chart-form">
            <div>
                <div>
                    <KendoWrappers.KendoPercentageInput
                        // 20200303 was: name="interest"
                        name="hypoInterest"
                        label="Interest"
                        value={_.get(formData, 'hypoInterest')}
                        {...inputPropsPercentage}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoPercentageInput
                        // 20200303 was: name="inflation"
                        name="hypoInflation"
                        label="Inflation"
                        value={_.get(formData, 'hypoInflation')}
                        {...inputPropsPercentage}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoCurrencyInput
                        // name="begBalance"
                        name="hypoBegBalance"
                        label="Beginning Balance"
                        decimals={2}
                        value={Formatters.getFloat(formData, 'hypoBegBalance')}
                        {...inputProps}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoCurrencyInput
                        // 20200303 was: name="currentMRCVal"
                        // name="recommendedMRCVal"
                        name="hypoMRCVal"
                        label="Monthly Reserve Contribution Value"
                        decimals={2}
                        // 20200303 was: value={Formatters.getFloat(formData, 'currentMRCVal')}
                        value={Formatters.getFloat(formData, 'hypoMRCVal')}
                        {...inputProps}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoPercentageInput
                        // 20200303 was: name="currentAnnualIncrease"
                        name="hypoAnnualIncrease"
                        label="Annual Increase"
                        // 20200303 was: value={_.get(formData, 'currentAnnualIncrease')}
                        value={_.get(formData, 'hypoAnnualIncrease')}
                        {...inputPropsPercentage}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoYearsInput
                        // 20200303 was: name="currentYears"
                        name="hypoYears"
                        label="Switch to Secondary Increase after __ Years"
                        min={0}
                        max={30}
                        // 20200303 was: value={Formatters.getInt(formData, 'currentYears')}
                        value={Formatters.getInt(formData, 'hypoYears')}
                        {...inputProps}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoPercentageInput
                        // 20200303 was: name="currentSecondaryAnnualIncrease"
                        name="hypoSecondaryAnnualIncrease"
                        label="Secondary Annual Increases"
                        // 20200303 was: value={_.get(formData, 'currentSecondaryAnnualIncrease')}
                        value={_.get(formData, 'hypoSecondaryAnnualIncrease')}
                        {...inputPropsPercentage}
                    />
                </div>
                <div>
                    <KendoWrappers.KendoCurrencyInput
                        name="hypoSA"
                        label="Special Assessment"
                        decimals={2}
                        value={Formatters.getFloat(formData, 'hypoSA')}
                        {...inputProps}
                    />
                </div>
            </div>
            <ButtonToolbar>
                <Button
                    key="report-chart-form-buttons-optimize-scenario"
                    {...buttonOptions}
                    bsStyle="success"
                    onClick={e => { if (handleOptimizeScenarioButton) { handleOptimizeScenarioButton(e); } }}
                >
                    <i className="fa fa-check" /> {appText('optimize-scenario')}
                </Button>
            </ButtonToolbar>

        </PortalReserveStudyFormSection>
    );
};

export const PortalReserveStudyForm = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleViewFundingDisclosure,
    handleEditOrderButton,
    handleSaveChanges,
    handleUpdateScenarioButton,
    handleCopyScenarioButton,
    handleOptimizeScenarioButton,
    handleViewPdf,
    numFormChanges,
    formData,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    return (
        <KendoWrappers.KendoHorizontalForm className="____k-form-inline reserve-study-form-container">
            <Row className="form-row">
                <Col xs={12}>
                    <PortalReserveStudyFormBeginningAssumptions
                        appText={appText}
                        handleFormInputChange={handleFormInputChange}
                        handleSubmitForm={handleSubmitForm}
                        handleSaveChanges={handleSaveChanges}
                        handleEditOrderButton={handleEditOrderButton}
                        handleUpdateScenarioButton={handleUpdateScenarioButton}
                        handleCopyScenarioButton={handleCopyScenarioButton}
                        handleOptimizeScenarioButton={handleOptimizeScenarioButton}
                        handleViewPdf={handleViewPdf}
                        formData={formData}
                        numFormChanges={numFormChanges}
                    />
                </Col>
            </Row>
        </KendoWrappers.KendoHorizontalForm>
    );
};



// WEBPACK FOOTER //
// ./src/report/portal-chartform.tsx